"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalChunks = void 0;
function totalChunks(fileSize) {
    const chunkSize = 4096;
    const hashesPerChunk = 128;
    function chunksAtLevel(chunkCount) {
        if (chunkCount <= 1) {
            return chunkCount;
        }
        const upperLevelChunks = Math.ceil(chunkCount / hashesPerChunk);
        return chunkCount + chunksAtLevel(upperLevelChunks);
    }
    const baseLevelChunks = Math.ceil(fileSize / chunkSize);
    return chunksAtLevel(baseLevelChunks);
}
exports.totalChunks = totalChunks;
